// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C11–C13 document journeys; existing financial and delivery contracts stay intact. */
.rcti-review-workspace.rcti-communication-backdrop {
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
  grid-template-rows: minmax(0, 1fr);
}
.rcti-review-workspace .rcti-communication-dialog {
  box-sizing: border-box;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.rcti-email-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgb(10 14 18 / 46%);
  color: var(--text-primary);
}
.rcti-email-preview-dialog {
  display: flex;
  flex-direction: column;
  width: min(1120px, 100%);
  max-height: min(92dvh, 980px);
  overflow: hidden;
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-xl);
  background: var(--surface-primary);
  box-shadow: 0 24px 80px rgb(0 0 0 / 35%);
}
.rcti-email-preview-header,
.rcti-email-preview-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
  border-bottom: 1px solid var(--border-subtle);
}
.rcti-email-preview-header span { color: var(--text-secondary); font-size: var(--font-size-caption-md); }
.rcti-email-preview-header h2 { margin: 3px 0 0; font-size: var(--font-size-h2); }
.rcti-email-preview-header button,
.rcti-email-preview-footer button {
  min-height: 40px;
  padding: 0 var(--space-4);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
  color: var(--text-primary);
  cursor: pointer;
}
.rcti-email-preview-header button { display: grid; place-items: center; width: 40px; padding: 0; }
.rcti-email-preview-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: var(--space-6);
  padding: var(--space-6);
  overflow: auto;
}
.rcti-email-preview-content.has-document { grid-template-columns: minmax(300px, .8fr) minmax(0, 1.2fr); }
.rcti-email-preview-fields { display: grid; align-content: start; gap: var(--space-4); }
.rcti-email-preview-fields label { display: grid; gap: var(--space-2); font-size: var(--font-size-body-sm); }
.rcti-email-preview-fields input,
.rcti-email-preview-fields textarea {
  width: 100%; box-sizing: border-box; padding: 11px 12px;
  border: 1px solid var(--border-subtle); border-radius: var(--radius-md);
  background: var(--surface-secondary); color: var(--text-primary);
  font: inherit; line-height: 1.55;
}
.rcti-email-preview-fields input[readonly] { color: var(--text-secondary); }
.rcti-email-preview-fields textarea { resize: vertical; min-height: 180px; }
.rcti-email-preview-rendered { min-width: 0; }
.rcti-email-preview-rendered h3 { margin: 0 0 var(--space-3); font-size: var(--font-size-body-md); }
.rcti-email-preview-paper { padding: var(--space-5); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); background: var(--surface-secondary); line-height: 1.65; white-space: pre-wrap; overflow-wrap: anywhere; }
.rcti-email-preview-meta { color: var(--text-secondary); font-size: var(--font-size-caption-md); }
.rcti-email-preview-message { margin-top: var(--space-4); }
.rcti-email-preview-attachment { margin: var(--space-5) 0 0; padding-top: var(--space-3); border-top: 1px solid var(--border-subtle); color: var(--text-secondary); font-size: var(--font-size-caption-md); }
.rcti-email-preview-document { margin-top: var(--space-5); max-height: 50vh; overflow: auto; }
.rcti-email-preview-footer { justify-content: flex-end; border-top: 1px solid var(--border-subtle); border-bottom: 0; }
.rcti-email-preview-footer button.primary { border-color: var(--interactive-default); background: var(--interactive-default); color: var(--text-on-interactive, #fff); font-weight: var(--font-weight-semibold); }
.rcti-email-preview-footer button:disabled,
.rcti-email-preview-header button:disabled { cursor: not-allowed; opacity: .6; }
@media (max-width: 760px) {
  .rcti-email-preview-backdrop { padding: 10px; }
  .rcti-email-preview-content,
  .rcti-email-preview-content.has-document { grid-template-columns: 1fr; padding: var(--space-4); }
}

.rcti-review-workspace .rcti-communication-dialog {
  padding: var(--space-8);
}
.rcti-review-workspace .rcti-workspace-back {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  border: 0;
  background: transparent;
  padding: 0;
  margin-bottom: var(--space-6);
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace .rcti-communication-heading-icon {
  display: none;
}
.rcti-review-workspace .rcti-communication-header h2 {
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-semibold);
  line-height: 1.25;
}
.rcti-review-workspace .rcti-review-context {
  margin: 0 0 var(--space-6);
}
.rcti-review-workspace .rcti-review-eligibility {
  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);
}
.rcti-eligibility-notice {
  grid-column: 1 / -1;
  margin: 0;
  background: var(--success-soft);
  border-color: var(--success-soft);
}
.rcti-eligibility-notice.is-blocked {
  background: var(--warning-soft);
}
.rcti-review-workspace .rcti-eligibility-notice p {
  margin: var(--space-2) 0 0;
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace .rcti-evidence-checks li {
  padding: var(--space-4) 0;
  gap: var(--space-3);
}
.rcti-review-workspace .rcti-evidence-checks li p {
  margin: 0;
}
.rcti-review-workspace .rcti-evidence-checks li > div strong::before {
  content: "✓";
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: var(--space-2);
  border-radius: 50%;
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.rcti-final-review-state {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin: var(--space-6) 0;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-final-review-state > button {
  margin-left: auto;
}
.rcti-review-workspace .rcti-review-columns {
  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);
}
.rcti-review-workspace .rcti-review-columns > form {
  border: 0;
  background: transparent;
  padding: 0;
  gap: var(--space-6);
}
.rcti-supplier-email-card,
.rcti-review-workspace .rcti-review-issue-info {
  display: grid;
  gap: var(--space-4);
  padding: var(--space-6);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  margin: 0;
}
.rcti-review-workspace
  :is(.rcti-supplier-email-card, .rcti-review-issue-info)
  :is(h2, h3) {
  margin: 0;
  font-size: var(--font-size-body-lg);
  font-weight: var(--font-weight-medium);
}
.rcti-review-workspace
  :is(.rcti-supplier-email-card, .rcti-review-issue-info)
  p {
  margin: 0;
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.rcti-review-workspace .rcti-communication-field {
  display: grid;
  gap: var(--space-2);
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace .rcti-communication-field :is(input, textarea) {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-review-workspace .rcti-consent {
  display: flex;
  align-items: start;
  gap: var(--space-3);
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.rcti-review-workspace .rcti-consent input {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 4px;
}
.rcti-review-workspace .rcti-final-review-footer {
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  flex-wrap: wrap;
  margin-top: var(--space-6);
  border-top: 1px solid var(--border-subtle);
  padding-top: var(--space-5);
}
.rcti-issued-journey .rcti-detail-layout {
  display: grid;
  grid-template-areas: none;
  grid-template-columns: minmax(0, 2.2fr) minmax(300px, 1fr);
  align-items: start;
  gap: var(--space-6);
}
.rcti-issued-document-column {
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.rcti-issued-journey .rcti-detail-aside {
  grid-area: auto;
}
.rcti-issued-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-4);
  margin-bottom: var(--space-5);
}
.rcti-issued-toolbar > div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
}
.rcti-issued-journey .rcti-detail-context {
  margin-top: var(--space-5);
  margin-bottom: var(--space-5);
  background: var(--success-soft);
  border: 1px solid var(--border-subtle);
}
.rcti-issued-journey
  :is(.rcti-detail-context-reference, .rcti-detail-header
    .rcti-document-number, .rcti-detail-header .rcti-status, .rcti-detail-header
    > small) {
  display: none;
}
.rcti-issued-journey .rcti-detail-aside .invoice-flow-card {
  padding: var(--space-6);
}
.rcti-issued-journey .rcti-detail-aside :is(h2, h3) {
  font-size: var(--font-size-body-lg);
  font-weight: var(--font-weight-medium);
}
.rcti-issued-journey :is(.rcti-detail-aside, .rcti-issued-document-column) p {
  font-size: var(--font-size-body-sm);
  line-height: 1.65;
}
.rcti-review-workspace .rcti-paper-identity h2,
.rcti-issued-journey .rcti-paper-identity h2 {
  font-size: var(--font-size-h2);
  line-height: 1.3;
}
.rcti-review-workspace .rcti-detail-document,
.rcti-issued-journey .rcti-detail-document {
  padding: var(--space-6);
  display: grid;
  gap: var(--space-4);
}
.rcti-review-workspace .rcti-paper-parties,
.rcti-issued-journey .rcti-paper-parties {
  padding-bottom: var(--space-4);
}
.rcti-review-workspace .rcti-detail-meta,
.rcti-issued-journey .rcti-detail-meta {
  gap: var(--space-4);
}
.rcti-review-workspace .rcti-document-table,
.rcti-issued-journey .rcti-document-table {
  min-width: 560px;
  font-size: var(--font-size-caption-md);
}
.rcti-review-workspace .rcti-detail-summary,
.rcti-issued-journey .rcti-detail-summary {
  display: flex;
  flex-direction: column-reverse;
  gap: var(--space-6);
}
.rcti-review-workspace .rcti-detail-summary > div:last-child,
.rcti-issued-journey .rcti-detail-summary > div:last-child {
  width: min(100%, 380px);
  margin-left: auto;
}
.rcti-issued-journey .rcti-detail-summary > div:first-child,
.rcti-review-workspace .rcti-detail-summary > div:first-child {
  width: 100%;
}
.rcti-supporting-documents {
  display: grid;
  gap: var(--space-4);
}
@media (max-width: 1000px) {
  .rcti-review-workspace .rcti-review-columns,
  .rcti-review-workspace .rcti-review-eligibility,
  .rcti-issued-journey .rcti-detail-layout {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 600px) {
  .rcti-review-workspace .rcti-communication-dialog {
    padding: var(--space-4);
  }
  .rcti-review-workspace .rcti-communication-header h2 {
    font-size: var(--font-size-h2);
  }
  .rcti-supplier-email-card,
  .rcti-review-workspace .rcti-review-issue-info,
  .rcti-issued-journey .rcti-detail-aside .invoice-flow-card {
    padding: var(--space-4);
  }
}
.rcti-review-workspace .rcti-final-review-state > button,
.rcti-review-workspace .rcti-review-issue-info > button,
.rcti-review-workspace .rcti-final-review-footer > button {
  display: inline-flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: normal 500 13px/normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.rcti-review-workspace .rcti-review-issue-info > .primary,
.rcti-review-workspace .rcti-final-review-footer > .primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-color: var(--interactive-default);
}
.rcti-review-workspace button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.rcti-review-workspace .rcti-detail-document,
.rcti-issued-journey .rcti-detail-document {
  align-content: start;
}
.rcti-invoice-preview-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  min-width: 0;
  padding: 0;
  background: var(--bg-primary);
}
.rcti-invoice-preview-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: none;
  overflow: hidden;
  color: var(--text-primary);
  background: var(--bg-primary);
}
.rcti-invoice-preview-dialog > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-4) max(var(--space-6), calc((100vw - 1200px) / 2));
  border-bottom: 1px solid var(--border-subtle);
}
.rcti-invoice-preview-dialog > header h2,
.rcti-invoice-preview-dialog > header p { margin: 0; }
.rcti-invoice-preview-dialog > header h2 { font-size: var(--font-size-body-lg); }
.rcti-invoice-preview-dialog > header p { margin-top: 3px; color: var(--text-secondary); font-size: var(--font-size-body-sm); }
.rcti-invoice-preview-actions {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}
.rcti-invoice-preview-dialog > header button {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  color: var(--text-secondary);
  background: var(--surface-primary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  cursor: pointer;
}
.rcti-invoice-preview-dialog > header .rcti-preview-issue-action {
  width: auto;
  height: auto;
  min-height: 40px;
  flex: 0 0 auto;
  padding: 0 var(--space-4);
  font: 500 var(--font-size-label-md) / normal var(--font-family-primary);
}
.rcti-invoice-preview-dialog > header .rcti-preview-issue-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.rcti-invoice-preview-document {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 0 var(--space-6) var(--space-6);
}
.rcti-invoice-preview-document .rcti-detail-document {
  width: min(100%, 820px);
  margin: 0 auto;
  padding: var(--space-8);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
}
.rcti-invoice-preview-document .rcti-document-table { min-width: 560px; }
@media (max-width: 600px) {
  .rcti-invoice-preview-dialog > header {
    flex-wrap: wrap;
    padding: var(--space-3) var(--space-4);
  }
  .rcti-invoice-preview-actions {
    margin-left: auto;
  }
  .rcti-invoice-preview-dialog > header .rcti-preview-issue-action {
    padding: 0 var(--space-3);
    font-size: var(--font-size-caption-md);
  }
  .rcti-invoice-preview-document { padding: 0 12px 12px; }
  .rcti-invoice-preview-document .rcti-detail-document { padding: var(--space-4); }
}
html:has(.rcti-invoice-preview-backdrop) .app-topbar {
  z-index: 1501 !important;
}
.rcti-review-workspace .rcti-paper-heading,
.rcti-issued-journey .rcti-paper-heading {
  min-height: 0;
}
.rcti-review-workspace .rcti-paper-parties,
.rcti-issued-journey .rcti-paper-parties {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.rcti-review-workspace .rcti-paper-identity .rcti-type-emphasis {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace .rcti-paper-business > .rcti-type-emphasis {
  font-size: var(--font-size-body-sm);
  color: var(--interactive-default);
}
.rcti-payment-history-panel {
  grid-template-columns: minmax(0, 1fr);
}
.rcti-issued-footer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
  margin-top: var(--space-6);
}
@media (max-width: 600px) {
  .rcti-review-workspace .rcti-paper-parties,
  .rcti-issued-journey .rcti-paper-parties {
    grid-template-columns: minmax(0, 1fr);
  }
}
.rcti-issued-document-column > .rcti-detail-document {
  grid-area: auto;
}
.rcti-issued-journey .rcti-detail-aside .invoice-flow-card {
  height: auto;
  min-height: 0;
  flex: none;
}
.rcti-review-workspace
  .rcti-evidence-checks
  li[data-check="blocked"]
  > div
  strong::before {
  content: "!";
  color: var(--danger-text);
  background: var(--danger-soft);
}
.rcti-review-workspace
  .rcti-evidence-checks
  li[data-check="confirm"]
  > div
  strong::before {
  content: "•";
}
.rcti-review-workspace
  .rcti-evidence-checks
  li[data-check="confirm"]
  .rcti-evidence-status {
  color: var(--text-secondary);
  background: var(--surface-secondary);
}
.rcti-issued-journey a {
  color: var(--interactive-default);
}
.rcti-issued-journey .rcti-balance-card > p {
  margin-bottom: var(--space-4);
}
.rcti-issued-journey .rcti-payment-breakdown {
  margin-top: var(--space-4);
}

/* Keep supplier email above the open document preview. */
.rcti-review-workspace .send-invoice-dialog-backdrop {
  z-index: 1600;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiDocumentJourney.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;EACtC,6CAA6C;AAC/C;AACA,kCAAkC,4BAA4B,EAAE,sCAAsC,EAAE;AACxG,gCAAgC,eAAe,EAAE,8BAA8B,EAAE;AACjF;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;AACjB;AACA,oCAAoC,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,UAAU,EAAE;AACjG;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,2CAA2C,2DAA2D,EAAE;AACxG,6BAA6B,aAAa,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACvF,mCAAmC,aAAa,EAAE,mBAAmB,EAAE,mCAAmC,EAAE;AAC5G;;EAEE,WAAW,EAAE,sBAAsB,EAAE,kBAAkB;EACvD,sCAAsC,EAAE,+BAA+B;EACvE,oCAAoC,EAAE,0BAA0B;EAChE,aAAa,EAAE,iBAAiB;AAClC;AACA,6CAA6C,4BAA4B,EAAE;AAC3E,sCAAsC,gBAAgB,EAAE,iBAAiB,EAAE;AAC3E,+BAA+B,YAAY,EAAE;AAC7C,kCAAkC,0BAA0B,EAAE,mCAAmC,EAAE;AACnG,4BAA4B,uBAAuB,EAAE,sCAAsC,EAAE,+BAA+B,EAAE,oCAAoC,EAAE,iBAAiB,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AACvO,2BAA2B,4BAA4B,EAAE,sCAAsC,EAAE;AACjG,8BAA8B,0BAA0B,EAAE;AAC1D,iCAAiC,0BAA0B,EAAE,2BAA2B,EAAE,0CAA0C,EAAE,4BAA4B,EAAE,sCAAsC,EAAE;AAC5M,+BAA+B,0BAA0B,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAC7F,6BAA6B,yBAAyB,EAAE,0CAA0C,EAAE,gBAAgB,EAAE;AACtH,4CAA4C,wCAAwC,EAAE,sCAAsC,EAAE,uCAAuC,EAAE,wCAAwC,EAAE;AACjN;6CAC6C,mBAAmB,EAAE,WAAW,EAAE;AAC/E;EACE,+BAA+B,aAAa,EAAE;EAC9C;6CAC2C,0BAA0B,EAAE,uBAAuB,EAAE;AAClG;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,iCAAiC;AACnC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,SAAS;AACX;AACA;;;EAGE,SAAS;EACT,mCAAmC;EACnC,sCAAsC;AACxC;AACA;;;EAGE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,0CAA0C;EAC1C,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,0DAA0D;EAC1D,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,mCAAmC;EACnC,iBAAiB;AACnB;AACA;;EAEE,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;;EAEE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;EAChB,sCAAsC;AACxC;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;;;IAGE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,8BAA8B;EAChC;EACA;;;IAGE,uBAAuB;EACzB;AACF;AACA;;;EAGE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,6EAA6E;EAC7E,eAAe;AACjB;AACA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,YAAY;EACZ,UAAU;EACV,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,uEAAuE;EACvE,6CAA6C;AAC/C;AACA;0CAC0C,SAAS,EAAE;AACrD,2CAA2C,mCAAmC,EAAE;AAChF,0CAA0C,eAAe,EAAE,4BAA4B,EAAE,mCAAmC,EAAE;AAC9H;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uEAAuE;AACzE;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA,sDAAsD,gBAAgB,EAAE;AACxE;EACE;IACE,eAAe;IACf,sCAAsC;EACxC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,sCAAsC;EACxC;EACA,iCAAiC,oBAAoB,EAAE;EACvD,uDAAuD,uBAAuB,EAAE;AAClF;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,0BAA0B;AAC5B;AACA;EACE;;IAEE,qCAAqC;EACvC;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;AACA;;;;;EAKE,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;AAChC;AACA;;;;;EAKE,YAAY;AACd;AACA;;;;EAIE,4BAA4B;EAC5B,oCAAoC;AACtC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;AAC5B;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf","sourcesContent":["/* C11–C13 document journeys; existing financial and delivery contracts stay intact. */\n.rcti-review-workspace.rcti-communication-backdrop {\n  height: 100dvh;\n  min-height: 0;\n  overflow: hidden;\n  grid-template-rows: minmax(0, 1fr);\n}\n.rcti-review-workspace .rcti-communication-dialog {\n  box-sizing: border-box;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n.rcti-email-preview-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1600;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: rgb(10 14 18 / 46%);\n  color: var(--text-primary);\n}\n.rcti-email-preview-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(1120px, 100%);\n  max-height: min(92dvh, 980px);\n  overflow: hidden;\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-xl);\n  background: var(--surface-primary);\n  box-shadow: 0 24px 80px rgb(0 0 0 / 35%);\n}\n.rcti-email-preview-header,\n.rcti-email-preview-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-5) var(--space-6);\n  border-bottom: 1px solid var(--border-subtle);\n}\n.rcti-email-preview-header span { color: var(--text-secondary); font-size: var(--font-size-caption-md); }\n.rcti-email-preview-header h2 { margin: 3px 0 0; font-size: var(--font-size-h2); }\n.rcti-email-preview-header button,\n.rcti-email-preview-footer button {\n  min-height: 40px;\n  padding: 0 var(--space-4);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n  color: var(--text-primary);\n  cursor: pointer;\n}\n.rcti-email-preview-header button { display: grid; place-items: center; width: 40px; padding: 0; }\n.rcti-email-preview-content {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: var(--space-6);\n  padding: var(--space-6);\n  overflow: auto;\n}\n.rcti-email-preview-content.has-document { grid-template-columns: minmax(300px, .8fr) minmax(0, 1.2fr); }\n.rcti-email-preview-fields { display: grid; align-content: start; gap: var(--space-4); }\n.rcti-email-preview-fields label { display: grid; gap: var(--space-2); font-size: var(--font-size-body-sm); }\n.rcti-email-preview-fields input,\n.rcti-email-preview-fields textarea {\n  width: 100%; box-sizing: border-box; padding: 11px 12px;\n  border: 1px solid var(--border-subtle); border-radius: var(--radius-md);\n  background: var(--surface-secondary); color: var(--text-primary);\n  font: inherit; line-height: 1.55;\n}\n.rcti-email-preview-fields input[readonly] { color: var(--text-secondary); }\n.rcti-email-preview-fields textarea { resize: vertical; min-height: 180px; }\n.rcti-email-preview-rendered { min-width: 0; }\n.rcti-email-preview-rendered h3 { margin: 0 0 var(--space-3); font-size: var(--font-size-body-md); }\n.rcti-email-preview-paper { padding: var(--space-5); border: 1px solid var(--border-subtle); border-radius: var(--radius-lg); background: var(--surface-secondary); line-height: 1.65; white-space: pre-wrap; overflow-wrap: anywhere; }\n.rcti-email-preview-meta { color: var(--text-secondary); font-size: var(--font-size-caption-md); }\n.rcti-email-preview-message { margin-top: var(--space-4); }\n.rcti-email-preview-attachment { margin: var(--space-5) 0 0; padding-top: var(--space-3); border-top: 1px solid var(--border-subtle); color: var(--text-secondary); font-size: var(--font-size-caption-md); }\n.rcti-email-preview-document { margin-top: var(--space-5); max-height: 50vh; overflow: auto; }\n.rcti-email-preview-footer { justify-content: flex-end; border-top: 1px solid var(--border-subtle); border-bottom: 0; }\n.rcti-email-preview-footer button.primary { border-color: var(--interactive-default); background: var(--interactive-default); color: var(--text-on-interactive, #fff); font-weight: var(--font-weight-semibold); }\n.rcti-email-preview-footer button:disabled,\n.rcti-email-preview-header button:disabled { cursor: not-allowed; opacity: .6; }\n@media (max-width: 760px) {\n  .rcti-email-preview-backdrop { padding: 10px; }\n  .rcti-email-preview-content,\n  .rcti-email-preview-content.has-document { grid-template-columns: 1fr; padding: var(--space-4); }\n}\n\n.rcti-review-workspace .rcti-communication-dialog {\n  padding: var(--space-8);\n}\n.rcti-review-workspace .rcti-workspace-back {\n  display: block;\n  width: fit-content;\n  border: 0;\n  background: transparent;\n  padding: 0;\n  margin-bottom: var(--space-6);\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace .rcti-communication-heading-icon {\n  display: none;\n}\n.rcti-review-workspace .rcti-communication-header h2 {\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.25;\n}\n.rcti-review-workspace .rcti-review-context {\n  margin: 0 0 var(--space-6);\n}\n.rcti-review-workspace .rcti-review-eligibility {\n  grid-template-columns: minmax(0, 2.2fr) minmax(280px, 1fr);\n}\n.rcti-eligibility-notice {\n  grid-column: 1 / -1;\n  margin: 0;\n  background: var(--success-soft);\n  border-color: var(--success-soft);\n}\n.rcti-eligibility-notice.is-blocked {\n  background: var(--warning-soft);\n}\n.rcti-review-workspace .rcti-eligibility-notice p {\n  margin: var(--space-2) 0 0;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace .rcti-evidence-checks li {\n  padding: var(--space-4) 0;\n  gap: var(--space-3);\n}\n.rcti-review-workspace .rcti-evidence-checks li p {\n  margin: 0;\n}\n.rcti-review-workspace .rcti-evidence-checks li > div strong::before {\n  content: \"✓\";\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-right: var(--space-2);\n  border-radius: 50%;\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.rcti-final-review-state {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin: var(--space-6) 0;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-final-review-state > button {\n  margin-left: auto;\n}\n.rcti-review-workspace .rcti-review-columns {\n  grid-template-columns: minmax(0, 1.45fr) minmax(320px, 1fr);\n}\n.rcti-review-workspace .rcti-review-columns > form {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  gap: var(--space-6);\n}\n.rcti-supplier-email-card,\n.rcti-review-workspace .rcti-review-issue-info {\n  display: grid;\n  gap: var(--space-4);\n  padding: var(--space-6);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  margin: 0;\n}\n.rcti-review-workspace\n  :is(.rcti-supplier-email-card, .rcti-review-issue-info)\n  :is(h2, h3) {\n  margin: 0;\n  font-size: var(--font-size-body-lg);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-review-workspace\n  :is(.rcti-supplier-email-card, .rcti-review-issue-info)\n  p {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.rcti-review-workspace .rcti-communication-field {\n  display: grid;\n  gap: var(--space-2);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace .rcti-communication-field :is(input, textarea) {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-review-workspace .rcti-consent {\n  display: flex;\n  align-items: start;\n  gap: var(--space-3);\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.rcti-review-workspace .rcti-consent input {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  margin-top: 4px;\n}\n.rcti-review-workspace .rcti-final-review-footer {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n  margin-top: var(--space-6);\n  border-top: 1px solid var(--border-subtle);\n  padding-top: var(--space-5);\n}\n.rcti-issued-journey .rcti-detail-layout {\n  display: grid;\n  grid-template-areas: none;\n  grid-template-columns: minmax(0, 2.2fr) minmax(300px, 1fr);\n  align-items: start;\n  gap: var(--space-6);\n}\n.rcti-issued-document-column {\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.rcti-issued-journey .rcti-detail-aside {\n  grid-area: auto;\n}\n.rcti-issued-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  margin-bottom: var(--space-5);\n}\n.rcti-issued-toolbar > div {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n}\n.rcti-issued-journey .rcti-detail-context {\n  margin-top: var(--space-5);\n  margin-bottom: var(--space-5);\n  background: var(--success-soft);\n  border: 1px solid var(--border-subtle);\n}\n.rcti-issued-journey\n  :is(.rcti-detail-context-reference, .rcti-detail-header\n    .rcti-document-number, .rcti-detail-header .rcti-status, .rcti-detail-header\n    > small) {\n  display: none;\n}\n.rcti-issued-journey .rcti-detail-aside .invoice-flow-card {\n  padding: var(--space-6);\n}\n.rcti-issued-journey .rcti-detail-aside :is(h2, h3) {\n  font-size: var(--font-size-body-lg);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-issued-journey :is(.rcti-detail-aside, .rcti-issued-document-column) p {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.65;\n}\n.rcti-review-workspace .rcti-paper-identity h2,\n.rcti-issued-journey .rcti-paper-identity h2 {\n  font-size: var(--font-size-h2);\n  line-height: 1.3;\n}\n.rcti-review-workspace .rcti-detail-document,\n.rcti-issued-journey .rcti-detail-document {\n  padding: var(--space-6);\n  display: grid;\n  gap: var(--space-4);\n}\n.rcti-review-workspace .rcti-paper-parties,\n.rcti-issued-journey .rcti-paper-parties {\n  padding-bottom: var(--space-4);\n}\n.rcti-review-workspace .rcti-detail-meta,\n.rcti-issued-journey .rcti-detail-meta {\n  gap: var(--space-4);\n}\n.rcti-review-workspace .rcti-document-table,\n.rcti-issued-journey .rcti-document-table {\n  min-width: 560px;\n  font-size: var(--font-size-caption-md);\n}\n.rcti-review-workspace .rcti-detail-summary,\n.rcti-issued-journey .rcti-detail-summary {\n  display: flex;\n  flex-direction: column-reverse;\n  gap: var(--space-6);\n}\n.rcti-review-workspace .rcti-detail-summary > div:last-child,\n.rcti-issued-journey .rcti-detail-summary > div:last-child {\n  width: min(100%, 380px);\n  margin-left: auto;\n}\n.rcti-issued-journey .rcti-detail-summary > div:first-child,\n.rcti-review-workspace .rcti-detail-summary > div:first-child {\n  width: 100%;\n}\n.rcti-supporting-documents {\n  display: grid;\n  gap: var(--space-4);\n}\n@media (max-width: 1000px) {\n  .rcti-review-workspace .rcti-review-columns,\n  .rcti-review-workspace .rcti-review-eligibility,\n  .rcti-issued-journey .rcti-detail-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 600px) {\n  .rcti-review-workspace .rcti-communication-dialog {\n    padding: var(--space-4);\n  }\n  .rcti-review-workspace .rcti-communication-header h2 {\n    font-size: var(--font-size-h2);\n  }\n  .rcti-supplier-email-card,\n  .rcti-review-workspace .rcti-review-issue-info,\n  .rcti-issued-journey .rcti-detail-aside .invoice-flow-card {\n    padding: var(--space-4);\n  }\n}\n.rcti-review-workspace .rcti-final-review-state > button,\n.rcti-review-workspace .rcti-review-issue-info > button,\n.rcti-review-workspace .rcti-final-review-footer > button {\n  display: inline-flex;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: normal 500 13px/normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.rcti-review-workspace .rcti-review-issue-info > .primary,\n.rcti-review-workspace .rcti-final-review-footer > .primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-color: var(--interactive-default);\n}\n.rcti-review-workspace button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rcti-review-workspace .rcti-detail-document,\n.rcti-issued-journey .rcti-detail-document {\n  align-content: start;\n}\n.rcti-invoice-preview-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: flex;\n  min-width: 0;\n  padding: 0;\n  background: var(--bg-primary);\n}\n.rcti-invoice-preview-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  max-height: none;\n  overflow: hidden;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n}\n.rcti-invoice-preview-dialog > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-4) max(var(--space-6), calc((100vw - 1200px) / 2));\n  border-bottom: 1px solid var(--border-subtle);\n}\n.rcti-invoice-preview-dialog > header h2,\n.rcti-invoice-preview-dialog > header p { margin: 0; }\n.rcti-invoice-preview-dialog > header h2 { font-size: var(--font-size-body-lg); }\n.rcti-invoice-preview-dialog > header p { margin-top: 3px; color: var(--text-secondary); font-size: var(--font-size-body-sm); }\n.rcti-invoice-preview-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n.rcti-invoice-preview-dialog > header button {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  flex: 0 0 40px;\n  color: var(--text-secondary);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n}\n.rcti-invoice-preview-dialog > header .rcti-preview-issue-action {\n  width: auto;\n  height: auto;\n  min-height: 40px;\n  flex: 0 0 auto;\n  padding: 0 var(--space-4);\n  font: 500 var(--font-size-label-md) / normal var(--font-family-primary);\n}\n.rcti-invoice-preview-dialog > header .rcti-preview-issue-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rcti-invoice-preview-document {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 0 var(--space-6) var(--space-6);\n}\n.rcti-invoice-preview-document .rcti-detail-document {\n  width: min(100%, 820px);\n  margin: 0 auto;\n  padding: var(--space-8);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n}\n.rcti-invoice-preview-document .rcti-document-table { min-width: 560px; }\n@media (max-width: 600px) {\n  .rcti-invoice-preview-dialog > header {\n    flex-wrap: wrap;\n    padding: var(--space-3) var(--space-4);\n  }\n  .rcti-invoice-preview-actions {\n    margin-left: auto;\n  }\n  .rcti-invoice-preview-dialog > header .rcti-preview-issue-action {\n    padding: 0 var(--space-3);\n    font-size: var(--font-size-caption-md);\n  }\n  .rcti-invoice-preview-document { padding: 0 12px 12px; }\n  .rcti-invoice-preview-document .rcti-detail-document { padding: var(--space-4); }\n}\nhtml:has(.rcti-invoice-preview-backdrop) .app-topbar {\n  z-index: 1501 !important;\n}\n.rcti-review-workspace .rcti-paper-heading,\n.rcti-issued-journey .rcti-paper-heading {\n  min-height: 0;\n}\n.rcti-review-workspace .rcti-paper-parties,\n.rcti-issued-journey .rcti-paper-parties {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.rcti-review-workspace .rcti-paper-identity .rcti-type-emphasis {\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace .rcti-paper-business > .rcti-type-emphasis {\n  font-size: var(--font-size-body-sm);\n  color: var(--interactive-default);\n}\n.rcti-payment-history-panel {\n  grid-template-columns: minmax(0, 1fr);\n}\n.rcti-issued-footer {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-subtle);\n  margin-top: var(--space-6);\n}\n@media (max-width: 600px) {\n  .rcti-review-workspace .rcti-paper-parties,\n  .rcti-issued-journey .rcti-paper-parties {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n.rcti-issued-document-column > .rcti-detail-document {\n  grid-area: auto;\n}\n.rcti-issued-journey .rcti-detail-aside .invoice-flow-card {\n  height: auto;\n  min-height: 0;\n  flex: none;\n}\n.rcti-review-workspace\n  .rcti-evidence-checks\n  li[data-check=\"blocked\"]\n  > div\n  strong::before {\n  content: \"!\";\n  color: var(--danger-text);\n  background: var(--danger-soft);\n}\n.rcti-review-workspace\n  .rcti-evidence-checks\n  li[data-check=\"confirm\"]\n  > div\n  strong::before {\n  content: \"•\";\n}\n.rcti-review-workspace\n  .rcti-evidence-checks\n  li[data-check=\"confirm\"]\n  .rcti-evidence-status {\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n}\n.rcti-issued-journey a {\n  color: var(--interactive-default);\n}\n.rcti-issued-journey .rcti-balance-card > p {\n  margin-bottom: var(--space-4);\n}\n.rcti-issued-journey .rcti-payment-breakdown {\n  margin-top: var(--space-4);\n}\n\n/* Keep supplier email above the open document preview. */\n.rcti-review-workspace .send-invoice-dialog-backdrop {\n  z-index: 1600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
